import axios, { AxiosInstance } from "axios";

// Simple factory; customize as needed (baseURL, auth, etc.)
export function createApiInstance(): AxiosInstance {
  const api = axios.create({
    baseURL: "https://api.tylt.money"
  });

  // (Optional) Attach auth token if you have one
  api.interceptors.request.use((config) => {
    const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
    if (token) {
      config.headers = config.headers ?? {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // (Optional) Centralize error handling/logging
  api.interceptors.response.use(
    (res) => res,
    (err) => {
      // You can normalize errors here if you like
      return Promise.reject(err);
    }
  );

  return api;
}
